import './EmojiShape.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var emojiShape = _7a468({defaultClassName:'_s37yxn0-3-5-0',variantClassNames:{active:{true:'_s37yxn1-3-5-0',false:'_s37yxn2-3-5-0'}},defaultVariants:{},compoundVariants:[]});